import { MentorStatusValues } from 'enums/MentorStatus';

export const mentorTags: MentorStatusValues[] = [
  'FILLING_FORM',
  'SIGNING_CHART',
  'TRAINING',
  'TRAINING_REGISTERED',
  'ACCEPTED',
  'AVAILABLE',
  'REFUSED',
  'MENTORSHIP_ACTIVE',
];

export const getIsMentorStatus = (
  status: string,
): status is MentorStatusValues => {
  return [
    'FILLING_FORM',
    'SIGNING_CHART',
    'TRAINING',
    'TRAINING_REGISTERED',
    'ACCEPTED',
    'AVAILABLE',
    'REFUSED',
    'MENTORSHIP_ACTIVE',
  ].includes(status);
};
